export default function regulationsSummaryReducer(state = [], action) {
   const { type, regulationsSummary, regulationId } = action
   switch (type) {
      case 'SET_REGULATIONS_SUMMARY':
         return regulationsSummary
      case 'SET_REGULATION_READ':
         regulationsSummary.forEach(regulation => {
            if (regulation.id === regulationId) {
               regulation.read = true
            }
         })
         return regulationsSummary
      default:
         return state
   }
}
